function validateInput(input) {
  // keep A–Z, a–z, dot, and space only; then cap length
  input.value = input.value.replace(/[^A-Za-z. ]/g, '').slice(0, 10);

  // Update live character count
  const counter = document.querySelector('.left_total');
  if (counter) counter.textContent = input.value.length;
}
$(document).on("click", '.custom_personalication_button', function(e) {  
$('.custom_personalization_popup').show().addClass('active');
});
$(document).on("click", '.custom_personalization_color', function(e) {  
$('.custom_personalization_color').removeClass('active');
$(this).addClass('active');
var active_color = $(this).attr('color');
var active_color_text = $(this).attr('color_text');
$('.custom_personalization_label_color strong').text(active_color_text);
  $('.personalization_text').trigger('input');
});
$(document).on("click", '.custom_personalization_popup_bg,.close_personalization', function(e) {  
$('.custom_personalization_popup').removeClass('active');
setTimeout(function () {
$('.custom_personalization_popup').hide();
 }, 600);
});

$(document).on("click", '.custom_personalization_reset', function(e) {  
$('.personalization_text').val('');
$('.personalization_text').trigger('input');
});

$(document).on('input', '.personalization_text', function () {
var text = $(this).val();
$('.upsell_product_additional input').val(text);
var inputText = $(this).val();
    inputText = inputText.replace(/ /g, "$");
if (inputText.length>0){
$('.upsell_content_main').addClass('active');
$('.custom_personalization_trigger_buy').removeAttr('disabled');
} else {
$('.upsell_content_main').removeClass('active');
$('.custom_personalization_trigger_buy').attr('disabled','disabled'); 
}
  const activeColor = $('.custom_personalization_color.active').attr('color') || 'default';
  const $target = $('.custom_texts');

  $target.empty(); // Clear previous letters

  for (let i = 0; i < inputText.length; i++) {
    const char = inputText[i];
    if (char !== ' ') {
      const $div = $('<div>')
        .addClass(`text_${char.toLowerCase()} color_${activeColor.toLowerCase()}`);
      $target.append($div);
    }
  }
});
$(document).on("click", '.custom_personalization_trigger_buy:not([disabled])', function(e) {  
$('button#AddToCart').trigger('click');
$('.custom_personalization_popup_bg').trigger('click');
});
 
$(document).on("click", '.upsell_content_main:not(.active) .css_selector_upsell', function(e) {  
$('.custom_personalication_button').trigger('click');
});
  